import { useQuery } from "@tanstack/react-query";
import {
  USER_CHILD_COUPON_COUNT,
  USER_CHILD_COUPON_HISTORY,
  USER_CHILD_PROFILE_SELECTED,
  USER_POINT_HISTORY,
} from "./querykeys";
import { readProfileId } from "./authFunctions";
import { request } from "./api";
import { PointHistory } from "@/types/point_history_list.types";
import { ResponseType } from "@/types/response.types";
import { ChildrenProfile } from "@/types/children_profile.types";

/** 선택한 어린이 프로필 조회 훅 */
export const useSelectedProfile = (profileId?: string | null) => {
  return useQuery(
    [
      USER_CHILD_PROFILE_SELECTED,
      profileId,
      localStorage.getItem("ggp_profileId"),
    ],
    async () => {
      const id = profileId || (await readProfileId());

      const result = await request<ResponseType<ChildrenProfile>>({
        method: "GET",
        url: `profile/selected/${id}`,
      });
      return result.data;
    },
    {
      enabled: true, // profileId가 없어도 동작하도록 enabled 조건 제거
      onError: (error) => {
        console.error("Query Error:", error);
      },
    }
  );
};

/** 선택된 프로필의 총합 쿠폰 개수 조회 훅 */
export const useCouponCount = () => {
  return useQuery(
    [USER_CHILD_COUPON_COUNT],
    async () => {
      const profileId = await readProfileId();
      const result = await request<ResponseType<any>>({
        method: "GET",
        url: `/coupon/${profileId}`,
      });
      return result.data;
    },
    {
      onError: (error) => {
        console.error("Query Error:", error);
      },
    }
  );
};

/** 선택 프로필 아이의 총합 포인트 및 포인트 리스트 조회 훅 */
export const usePointHistory = () => {
  return useQuery(
    [USER_POINT_HISTORY],
    async () => {
      const profileId = await readProfileId();
      const result = await request<
        ResponseType<{
          totalPoints: number;
          pointHistory: PointHistory[];
        }>
      >({
        method: "GET",
        url: `/point/history/${profileId}`,
      });
      return result.data;
    },
    {
      onError: (error) => {
        console.error("Query Error:", error);
      },
    }
  );
};

/** 쿠폰 히스토리 조회 훅 */
export const useCouponHistory = () => {
  return useQuery(
    [USER_CHILD_COUPON_HISTORY],
    async () => {
      const profileId = await readProfileId();
      const result = await request<ResponseType<any>>({
        method: "GET",
        url: `/coupon/history/${profileId}`,
      });
      return result.data;
    },
    {
      onError: (error) => {
        console.error("Query Error:", error);
      },
    }
  );
};
